import { render, staticRenderFns } from "./PixCard.vue?vue&type=template&id=a9f24894&"
import script from "./PixCard.vue?vue&type=script&lang=js&"
export * from "./PixCard.vue?vue&type=script&lang=js&"
import style0 from "./PixCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports